export default "__VITE_ASSET__Dyl$Iye2__"